import axios from "./axios";
import qs from "qs";

export default {
  fetchExchanges(params) {
    return axios.get("/node/fetchExchanges", {
      params: params,
    });
  },
  updateExchangeStatus(data) {
    return axios.post("/node/updateExchangeStatus", qs.stringify(data));
  },
  updateExchangeAttachment(data) {
    return axios.post("/node/updateExchangeAttachment", qs.stringify(data));
  },
};
